<template>
  <div class="mobileNavCtn">
    <div class="headerInfo">
      <div class="leftCtn">
        <div class="logo">博城机器人</div>
      </div>
      <div class="rightCtn">
        <div class="iconCtn" :class="{ 'close': showNav }" @click="showNav = !showNav">
          <div class="line line1"></div>
          <div class="line line2"></div>
          <div class="line line3"></div>
        </div>
      </div>
    </div>
    <div class="screenAll" :class="{ 'showAll': showNav }">
      <div class="navList">
        <el-menu class="el-menu-vertical-demo" router>
          <el-menu-item index="/mobile/home">
            <template slot="title">
              <div class="label">首页</div>
            </template>
          </el-menu-item>
          <el-menu-item index="/mobile/xietong">
            <template slot="title">
              <div class="label">协同平台</div>
            </template>
          </el-menu-item>
          <el-menu-item index="/mobile/chanping">
            <template slot="title">
              <div class="label">产品中心</div>
            </template>
          </el-menu-item>
          <el-submenu index="3">
            <template slot="title">
              <div class="label">产品列表</div>
            </template>
            <el-menu-item-group>
              <el-menu-item index="/mobile/productA">室内清洁机器人小普SN300</el-menu-item>
              <el-menu-item index="/mobile/productB">室内清洁机器人小普SN200</el-menu-item>
              <el-menu-item index="/mobile/productC">室外清洁机器人小普PS100</el-menu-item>
              <el-menu-item index="/mobile/productD">室外清洁机器人小普PS200</el-menu-item>
            </el-menu-item-group>
          </el-submenu>
          <el-menu-item index="/mobile/about">
            <template slot="title">
              <div class="label">关于博城</div>
            </template>
          </el-menu-item>
          <el-menu-item index="/mobile/fuwu">
            <template slot="title">
              <div class="label">服务案例</div>
            </template>
          </el-menu-item>
          <el-menu-item index="/mobile/contact">
            <template slot="title">
              <div class="label">联系我们</div>
            </template>
          </el-menu-item>
        </el-menu>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Mobileheader',
  data() {
    return {
      showNav: false
    }
  },
  methods: {
  },
  mounted() {
    console.log('haha')
  }
}
</script>

<style lang="scss" scoped>
.mobileNavCtn {
  position: fixed;
  background: #000b12;
  left: 0;
  right: 0;
  color: #fff;
  z-index: 99;

  .headerInfo {
    height: 40px;
    display: flex;
    justify-content: space-between;
    padding: 0 20px;
    align-items: center;
    max-width: 100%;

    .leftCtn {
      display: flex;

      .logo {
        font-size: 18px;
        font-weight: 700;
        line-height: 32px;
        letter-spacing: 1px;
      }
    }

    .rightCtn {
      position: relative;
      width: 25px;
      height: 100%;

      .iconCtn {
        position: relative;
        height: 100%;

        &.close {
          .line1 {
            transform-origin: left;
            transform: rotateZ(45deg);
          }

          .line2 {
            background: transparent;
          }

          .line3 {
            transform-origin: left;
            transform: rotateZ(-45deg);
          }
        }

        .line {
          position: absolute;
          height: 2px;
          background: #a0a0a0;
          width: 25px;
          transition: 0.4s ease;

          &.line1 {
            top: 10px;
          }

          &.line2 {
            top: 19px;
          }

          &.line3 {
            bottom: 10px;
          }
        }
      }
    }
  }

  .screenAll {
    position: fixed;
    background: #fff;
    top: 40px;
    bottom: calc(100% - 40px);
    left: 0;
    right: 0;
    transition: 0.4s ease;
    color: #333;
    overflow: hidden;

    &.showAll {
      bottom: 0;
    }

    .navList {
      height: 100%;

      .label {
        color: #333;
        padding: 0 20px;
        font-size: 16px;
      }

      // ::v-deep .el-submenu {
      //   padding: 0 20px;
      // }
    }
  }

}
</style>
